import styles from './Grid.module.scss';
import className from 'classnames/bind';

let cx = className.bind(styles);

export function Grid({ id, children, colCount = 1, className, alignItems, collapseMobile = true, ...props}) {
  const classNameArray = className?.split(' ') || [];
  return (
    <div id={id} className={cx(['ns_grid', 'grid', `col-count-${colCount}`, ...classNameArray, alignItems && `alignItems-${alignItems}`, collapseMobile && 'collapseMobile'])} {...props}>
      {children}
    </div>
  );
}
